import { UUID_regex } from "Utils/General/KeyGenerator";
import { AddSchema } from "mobx-firelink";
export class MapObject {
    constructor(initialData) {
        this.Extend(initialData);
    }
}
// not sure why LabelComp needs to be a dependency, but whatever
AddSchema("MapObject", ["LabelComp"], () => ({
    properties: {
        name: { type: "string" },
        position: { $ref: "Vector2i" },
        shape: { $ref: "ShapeComp" },
        label: { $ref: "LabelComp" },
        //parents: {$ref: "ParentSet"},
        parent: { $ref: "UUID" },
        children: { $ref: "ChildSet" },
    },
}));
AddSchema("ChildSet", { patternProperties: { [UUID_regex]: { type: "boolean" } } });
/*export type ChildSet = { [key: number]: ChildEntry; };
AddSchema({patternProperties: {"^[0-9]+$": {$ref: "ChildEntry"}}}, "ChildSet");
export type ChildEntry = {_: boolean;}
AddSchema({
    properties: {
        _: {type: "boolean"},
    },
    required: ["_"],
}, "ChildEntry");*/ 
